module.exports = __webpack_public_path__ + "static/img/sjbanner1.4b87957.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/view/images/sjbanner1.jpg
// module id = pJez
// module chunks = 1